import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import {
    AddCompetitionWrapper,
    AddedCompetitionWrapper,
    TrashIconWrapper,
    CompetitionLabel,
    AddCompetitionRow,
    AddedCompetitionLabel,
    AddedCompetitionId,
    CompetitionError,
    AddCompetitionButtonWrapper,
} from './SportsFilters.style';
import { CustomizedSportsState } from 'src/AppState/CmsState/SportsState/SportsState';
import { Label } from 'src/domains/layouts/shared/typography/Content.style';

interface PropsType {
    sportState: CustomizedSportsState;
}

export const AddCompetition = observer(({ sportState }: PropsType) => {
    const { websocketV2 } = useAppStateContext();
    const {
        activeFilter,
        filtersMap,
        handleAddCompetition,
        handleDeleteCompetition,
        competitionName,
        competitionIdInput,
    } = sportState;

    const filterItem = activeFilter === null ? null : filtersMap.get(activeFilter) ?? null;

    if (filterItem === null) {
        return null;
    }

    return (
        <AddCompetitionWrapper>
            <Input
                label='Competition id'
                formInputState={competitionIdInput}
                dataTest='custom-filter-competition-input'
            />

            {competitionName === null ? (
                competitionIdInput.value.length > 0 ? (
                    <CompetitionError>Invalid competition</CompetitionError>
                ) : null
            ) : (
                <AddCompetitionRow>
                    <CompetitionLabel data-test='custom-filter-competition-preview'>{competitionName}</CompetitionLabel>
                    <AddCompetitionButtonWrapper
                        onClick={handleAddCompetition}
                        dataTest='custom-filter-competition-add-button'
                    >
                        Add
                    </AddCompetitionButtonWrapper>
                </AddCompetitionRow>
            )}

            <div>
                <Label>Added competitions</Label>
                {filterItem.competitionIds.map((elem) => {
                    const competitionModel = websocketV2.getCompetitionModel(elem);

                    if (competitionModel !== null && activeFilter !== null) {
                        return (
                            <AddedCompetitionWrapper key={elem}>
                                <AddedCompetitionId>ID: {competitionModel.id}</AddedCompetitionId>
                                <AddedCompetitionLabel>{competitionModel.name}</AddedCompetitionLabel>
                                <TrashIconWrapper
                                    onClick={(): void => handleDeleteCompetition(activeFilter, competitionModel.id)}
                                />
                            </AddedCompetitionWrapper>
                        );
                    }
                })}
            </div>
        </AddCompetitionWrapper>
    );
});
